module.exports = require('./dist/config/inputs');
